module.exports = __webpack_public_path__ + "assets/img/shanchu.da83146d.svg";